"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFromIntervalApi = exports.convertToIntervalApi = exports.IntervalApi = void 0;
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var IntervalApi = (function () {
    function IntervalApi(start, length) {
        this.start = start;
        this.length = Math.max(0, length);
    }
    Object.defineProperty(IntervalApi.prototype, "end", {
        get: function () { return this.start + this.length; },
        enumerable: false,
        configurable: true
    });
    return IntervalApi;
}());
exports.IntervalApi = IntervalApi;
function convertToIntervalApi(curr) {
    return new IntervalApi(curr.start, curr.length);
}
exports.convertToIntervalApi = convertToIntervalApi;
function convertFromIntervalApi(curr) {
    return new fixed_1.FixedInterval(curr.start, curr.length);
}
exports.convertFromIntervalApi = convertFromIntervalApi;
